export default {
  ori: {
    97: '0xC5FD6F3eB1f63082Daee9e09E17D870005962309',
    250: '0x0575f8738EFdA7F512e3654F277C77e80C7d2725',
  },
  mechs: {
    97: '0xcba0FA601C44509e671283d071c600EFA7EdDC6a',
    250: '0x85c85647e1A79c2b8bc3Ed2B6a1DdE326eeC66c5',
  },
  syrup: {
    97: '0xfE1e507CeB712BDe086f3579d2c03248b2dB77f9',
    250: '0x009cF7bC57584b7998236eff51b98A168DceA9B0',
  },
  hypr: {
    97: '0x03D6BD3d48F956D783456695698C407A46ecD54d',
    250: '0xbc2451AaD349b6B43FD05F4F0cC327F8A6bcA2d4',
  },
  masterChef: {
    97: '0xc605158c53dac91E8650849690881F77f182442c',
    250: '0x90Df158ff7c31aD1d81ddDb1D8ab9d0eCBCeDa20',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    250: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  wbnb: {
    97: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
    250: '0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83',
  },
  lottery: {
    97: '0x99c2EcD51d52c036B00130d882Bc65f20Fdecf9f',
    250: '0x3C3f2049cc17C136a604bE23cF7E42745edf3b91',
  },
  lotteryNFT: {
    97: '0x8175c10383511b3a1C68f9dB222dc14A19CC950e',
    250: '0x5e74094Cd416f55179DBd0E45b1a8ED030e396A1',
  },
  mulltiCall: {
    250: '0x35dbe80BA02c20BDc57c520Fa73a4dC46B3a0A24',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    250: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    97: '',
  },
  ust: {
    250: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
    97: '',
  },
  pancakeProfile: {
    250: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0xfb3310CcA65fe9479a3590206Be3CEEC70DE77FE',
  },
  pancakeRabbits: {
    250: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  rabbitMintingFarm: {
    250: '0x1C99222F857C1d72234703eC5b9Ed88089Bd7091',
    97: '0x8f4739a48883Fdd89b65DC245dD5774fC8f44a67',
  },
  eth: {
    250: '0x74b23882a30290451a17c44f4f05243b6b58c76d',
    97: '',
  },
  claimRefund: {
    250: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
  },
}
